import {
    MaintenanceJob,
    MaintenanceJobAssignment,
    MaintenanceTask,
    MaintenanceTaskType,
    translateMaintenanceJob,
} from 'aos-services/src/services/tasks/types/task/MaintenanceTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { Box, HStack, Text } from 'aos-ui-universal'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

import type { PropsListEntry } from '../PropsListEntry'

export const maintenanceTaskPropertyList = (
    t: MaintenanceTask | TaskTemplate<MaintenanceTask>,
): PropsListEntry[] => [
    [
        'tasks.task-preview.maintenance.assignments',
        !!t.assignments?.length && (
            <Box>
                {t.assignments.map((a, index) => (
                    <Box
                        key={index}
                        className={twMerge(
                            index === 0 ? 'pt-2' : 'pt-4',
                            index < t.assignments!.length - 1 &&
                                'border-b border-solid border-border-subtle pb-2',
                        )}
                    >
                        {a.job && <MaintenanceJobLabel job={a.job} />}
                        {a.job?.jobType === MaintenanceTaskType.Brushes && (
                            <MaintenanceJobAssignmentDetails assignment={a} />
                        )}
                    </Box>
                ))}
            </Box>
        ),
    ],
]

interface MaintenanceJobLabelProps {
    job: MaintenanceJob
}

const MaintenanceJobLabel: FC<MaintenanceJobLabelProps> = ({ job }) => {
    const { t: translate } = useTranslation()
    return (
        <Text size='P3' weight='regular' tone='default'>
            {translateMaintenanceJob(translate)(job)}
        </Text>
    )
}

interface MaintenanceJobAssignmentDetailsProps {
    assignment: MaintenanceJobAssignment
}

export const MaintenanceJobAssignmentDetails: FC<MaintenanceJobAssignmentDetailsProps> = ({
    assignment,
}) => {
    const { t: translate } = useTranslation()
    const details: [string, string | number][] = [
        ['task-preview.maintenance.assignments.brushes-vehicle', assignment.brushesVehicle.label],
        ['task-preview.maintenance.assignments.brushes-brand', assignment.brushesBrand.name],
        [
            'task-preview.maintenance.assignments.engine-last-shift-hours',
            assignment.engineLastShiftHours,
        ],
        [
            'task-preview.maintenance.assignments.brushes-last-shift-hours',
            assignment.brushesLastShiftHours,
        ],
        ['task-preview.maintenance.assignments.total-hours', assignment.totalHours],
    ]

    return (
        <Box className='pt-2'>
            {details.map(([key, value]) => (
                <HStack key={key} className='items-center justify-between pb-2'>
                    <Text size='P3' weight='light' tone='muted'>
                        {`${translate(key, { ns: 'tasks' })}:`}
                    </Text>
                    <Text size='P3' tone='default' className='pl-1'>
                        {value}
                    </Text>
                </HStack>
            ))}
        </Box>
    )
}
